import '.a{display:flex;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.do{background:var(--palette-white);}.ssr-plugin'
import '.ac{flex-grow:1;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ad{max-width:77.5rem;}.ssr-plugin'
import '.h1{justify-content:stretch;}.ssr-plugin'
import '.bu{position:sticky;}.ssr-plugin'
import '.bf{top:0px;}.ssr-plugin'
import '.c0{z-index:10;}.ssr-plugin'
import '.gb{padding-block:1rem;}.ssr-plugin'
import '.gc{height:3rem;}.ssr-plugin'
import '.ag{justify-content:space-between;}.ssr-plugin'
import '.aj{flex-wrap:wrap;}.ssr-plugin'
import '.h2{margin-bottom:0px;}.ssr-plugin'
import '.h3{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.fv{margin-top:2rem;}.ssr-plugin'
import '.h4{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="a r ax b do"
      >
        <div className="ac a t ax b"
        >
          <div className="ad a b h1 bu bf c0 do"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="gb gc a ag t aj"
            >
              <styled.span className="h2"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="h3 a b r fv h4 ad"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
